import React from "react";
import ReactPaginate from 'react-paginate';
import {encode as base64_encode} from 'base-64';
import queryString from 'query-string';
import { ReactSession } from 'react-client-session';

import { Helpers } from "../../config/Helpers";

import ModalCabang from "../../components/ModalCabang";
import ModalLokasi from "../../components/ModalLokasi";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

class Wishlist extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            productData: [],
            offset: 0,
            perPage: 20,
            currentPage: 0,
            branchName: (ReactSession.get("branch_name")) ? ReactSession.get("branch_name") : 'JAKARTA',
            lokasiNama: (ReactSession.get("sess_order_lokasi_nama")) ? ReactSession.get("sess_order_lokasi_nama") : '',
            setModal: '',
            search: '',
            orderType: (ReactSession.get("order_type")) ? ReactSession.get("order_type") : 'Grosir',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            urlParam: queryString.parse(window.location.search),
            modalOpen: '',
            dataFilterJenis: [
                { name: 'Semua Jenis', value: 'all', image: 'https://waroq.com/WRQBACKEND/_Uploaded/Kategori/kb_all.png' }
            ],
            dataFilterKategori: [
                { name: 'Semua Kategori', value: 'all', image: 'https://waroq.com/WRQBACKEND/_Uploaded/Kategori/kb_all.png' }
            ],
            dataFilterOrder: [
                { name: 'Paling Sesuai', value: 'all' },
                { name: 'Terlaris', value: 'terlaris' },
                { name: 'Termurah', value: 'termurah' },
                { name: 'Termahal', value: 'termahal' },
                { name: 'Nama Barang Abjad Terkecil', value: 'nama_asc' },
                { name: 'Nama Barang Abjad Terbesar', value: 'nama_desc' },
            ],
            selectedIdJenis: 'all',
            selectedIdKategori: 'all',
            selectedIdOrder: 'all',
        };
        this.handlePageClick = this.handlePageClick.bind(this);
        this.refCabang = React.createRef();
        this.refLokasi = React.createRef();
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getGoodsType();
            this.getGoodsTypeDetails();

            if(this.state.urlParam.search){
                this.setState({
                    search: this.state.urlParam.search,
                }, () => {
                    this.getProduct();
                });
            }else{
                this.getProduct();
            }
        }
    }

    getLabel = (list, value) => {
        const found = list.filter((item) => item.value === value);
        return (found.length > 0) ? found[0].name : '';
    };

    getGoodsType = () => {
        Helpers.getGoodsType().then(res => {
            if(res && res.length > 0){
                const newData = res.map((item) => {
                    return { name: item.JenisBarang, value: item.KodeJenisBarang, image: item.img_url };
                });

                this.setState({
                    dataFilterJenis: [
                        { name: 'Semua Jenis', value: 'all', image: 'https://waroq.com/WRQBACKEND/_Uploaded/Kategori/kb_all.png' }
                    ].concat(newData)
                });
            }
        })
    };

    getGoodsTypeDetails = () => {
        Helpers.getGoodsTypeDetails((this.state.selectedIdJenis === 'all') ? '' : this.state.selectedIdJenis).then(res => {
            if(res && res.length > 0){
                const newData = res.map((item) => {
                    return { name: item.KategoriBarang, value: item.KodeKategoriBarang, image: item.img_url };
                });

                this.setState({
                    dataFilterKategori: [
                        { name: 'Semua Kategori', value: 'all', image: 'https://waroq.com/WRQBACKEND/_Uploaded/Kategori/kb_all.png' }
                    ].concat(newData)
                });
            }else{
                this.setState({
                    dataFilterKategori: [
                        { name: 'Semua Kategori', value: 'all', image: 'https://waroq.com/WRQBACKEND/_Uploaded/Kategori/kb_all.png' }
                    ]
                });
            }
        })
    };

    getProduct = () => {
        this.setState({ productData: [], postData: '' });

        const jenisParam = (this.state.selectedIdKategori !== 'all') ? this.state.selectedIdKategori : (this.state.selectedIdJenis !== 'all') ? this.state.selectedIdJenis : '';

        Helpers.getWishlist(this.state.sessUserCode, jenisParam, this.state.branchCode, 'yes', this.state.search, this.state.selectedIdOrder).then(res => {
            this.prepareProduct(res);
        })
    };

    prepareProduct = (res) => {
        const sortData = (res) ? res : [];

        this.setState({
            productData: sortData
        });

        const slice = sortData.slice(this.state.offset, this.state.offset + this.state.perPage)
        const postData = slice.map((object, i) => {
            return <div className="col-lg-1-5 col-md-4 col-6 col-sm-6 mb-15" onClick={() => {this.handleProductClick(object)}}>
                <div className="product-cart-wrap" style={{'border': '0px', 'background-color': 'unset'}}>
                    <div className="product-img-action-wrap" style={{'padding': 'unset', 'border-bottom-right-radius': '15px', 'border-bottom-left-radius': '15px'}}>
                        <div className="product-img product-img-zoom" style={{'padding': '5px'}}>
                            <a href="#">
                                <img className="default-img square-img"
                                     src={object.img_url} alt=""/>
                                <img className="hover-img"
                                     src={object.img_url} alt=""/>
                            </a>
                        </div>
                    </div>
                    <div className="product-content-wrap mt-15" style={{'padding': 0}}>
                        <h2 style={{'font-size': '14px', 'height': 'auto', 'margin-top': '5px'}}><a href="#">{object.NamaBarang}</a></h2>

                        <div style={{'display': 'flex', 'alignItems': 'center', 'gap': '6px'}}>
                            <img className="hover-img" src={'./assets/imgs/icon/ic_grosir.png'} width="20" alt=""/>
                            <strong><span style={{'font-size': '14px'}}>Rp {object.HargaGrosirFormatTerkecil} / {object.UnitBarangTerkecil}</span></strong>
                        </div>
                        <div style={{'display': 'flex', 'alignItems': 'center', 'gap': '6px'}}>
                            <img className="hover-img" src={'./assets/imgs/icon/ic_retail.png'} width="20" alt=""/>
                            <span style={{'font-size': '14px'}}>Rp {object.HargaRetailFormatTerkecil} / {object.UnitBarangTerkecil}</span>
                        </div>
                    </div>
                </div>
            </div>
        })

        this.setState({
            pageCount: Math.ceil(sortData.length / this.state.perPage),
            postData
        });
    };

    getProductSkeleton = () => {
        const totalSkeleton = [1,2,3,4,5];
        return totalSkeleton.map((object, i) => {
            return <div className="col-lg-1-5 col-md-4 col-6 col-sm-6">
                <div className="product-cart-wrap mb-30">
                    <div className="product-img-action-wrap">
                        <Skeleton height={100} />
                    </div>
                    <div className="product-content-wrap">
                        <h2 style={{'font-size': '12px', 'height': '44px'}}><a href="#"><Skeleton /></a></h2>
                        <div className="product-card-bottom" style={{'margin-top': 'unset'}}>
                            <div className="product-price">
                                <span style={{'font-size': '15px'}}><Skeleton /></span>
                                <span style={{'font-size': '12px'}} className="old-price"><Skeleton /></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        });
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.prepareProduct(this.state.productData)
        });

    };

    handleProductClick = (object) => {
        ReactSession.set("product_id", object.KodeBarang);
        ReactSession.set("product_name", object.NamaBarang);
        ReactSession.set("product_category", object.JenisBarang);
        ReactSession.set("product_image", object.img_url);
        window.location.href = "product";
    };

    handleSearch = (e) => {
        e.preventDefault();

        this.setState({
            currentPage: 0,
            offset: 0
        }, () => {
            this.getProduct()
        });
    };

    openModal = (modal) => {
        this.setState({ modalOpen: modal });
    };

    closeModal = () => {
        this.setState({ modalOpen: '' });
    };

    selectJenis = (value) => {
        this.setState({
            selectedIdJenis: value,
            selectedIdKategori: 'all',
            modalOpen: '',
            currentPage: 0,
            offset: 0
        }, () => {
            this.getGoodsTypeDetails();
            this.getProduct();
        });
    };

    selectKategori = (value) => {
        this.setState({
            selectedIdKategori: value,
            modalOpen: '',
            currentPage: 0,
            offset: 0
        }, () => {
            this.getProduct();
        });
    };

    selectOrder = (value) => {
        this.setState({
            selectedIdOrder: value,
            modalOpen: '',
            currentPage: 0,
            offset: 0
        }, () => {
            this.getProduct();
        });
    };

    render() {
        return (
            <>
                { this.state.setModal }

                <ModalCabang ref={this.refCabang} />
                <ModalLokasi ref={this.refLokasi} />

                <main className="main background-base-new">
                    <div className="shop-hero">
                        <div className="shop-hero-top">
                            <div className="shop-hero-branch" onClick={() => { this.refCabang.current.open() }}>
                                <i className="fi-rs-marker"></i>
                                Cabang <strong>{this.state.branchName}</strong>
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                            <div className="shop-hero-delivery" onClick={() => { this.refLokasi.current.open() }}>
                                Dikirim ke <strong>{this.state.lokasiNama || '-'}</strong>
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                        </div>

                        <div className="shop-hero-search">
                            <form method="post" onSubmit={(e) => {this.handleSearch(e)}}>
                                <i className="fi-rs-search"></i>
                                <input type="text" placeholder="Cari produk wishlist ..." value={this.state.search} onChange={e => this.setState({search: e.target.value})}/>
                            </form>
                        </div>

                        <div className="shop-filter-row">
                            <div className="shop-filter-chip" onClick={() => {this.openModal('jenis')}}>
                                {this.getLabel(this.state.dataFilterJenis, this.state.selectedIdJenis)}
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                            <div className="shop-filter-chip" onClick={() => {this.openModal('kategori')}}>
                                {this.getLabel(this.state.dataFilterKategori, this.state.selectedIdKategori)}
                                <i className="fi-rs-angle-small-down ml-5"></i>
                            </div>
                            <div className="shop-filter-chip shop-filter-chip-icon" onClick={() => {this.openModal('order')}}>
                                <i className="fi-rs-apps-sort"></i>
                            </div>
                        </div>
                    </div>

                    <div className="container mt-15 mb-5">
                        <div className="row">
                            <div className="col-12">
                                <div id={'productEl'} className="row product-grid">
                                    {
                                        this.state.postData && this.state.postData.length > 0 ? (
                                            this.state.postData
                                        ) : this.state.postData && this.state.postData.length === 0 ? (
                                            <div className="order-empty" style={{width: '100%'}}>
                                                <i className="fi-rs-heart"></i>
                                                <p>Belum ada produk di wishlist kamu</p>
                                            </div>
                                        ) : (
                                            this.getProductSkeleton()
                                        )
                                    }
                                </div>
                                <div className="pagination-area mt-10 mb-40">
                                    <nav aria-label="Page navigation example">
                                        <ReactPaginate
                                            previousLabel={<i className="fi-rs-arrow-small-left"></i>}
                                            previousClassName={"page-item"}
                                            previousLinkClassName={"page-link"}
                                            nextLabel={<i className="fi-rs-arrow-small-right"></i>}
                                            nextClassName={"page-item"}
                                            nextLinkClassName={"page-link"}
                                            breakLabel={"..."}
                                            breakClassName={"page-link dot"}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={1}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={"pagination justify-content-start"}
                                            activeClassName={"page-item active"}
                                            activeLinkClassName={"page-link"}
                                            pageClassName={"page-item"}
                                            pageLinkClassName={"page-link"}/>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>

                {/* Modal Filter Jenis */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'jenis' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Pilih Jenis Barang</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataFilterJenis.map((item, i) => {
                                    const active = this.state.selectedIdJenis === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat modal-picker-item-image' + (active ? ' active' : '')}
                                            onClick={() => {this.selectJenis(item.value)}}
                                        >
                                            <img src={item.image} alt="" />
                                            <span className="modal-picker-item-text">{item.name}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                {/* Modal Filter Kategori */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'kategori' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Pilih Kategori Barang</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataFilterKategori.map((item, i) => {
                                    const active = this.state.selectedIdKategori === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat modal-picker-item-image' + (active ? ' active' : '')}
                                            onClick={() => {this.selectKategori(item.value)}}
                                        >
                                            <img src={item.image} alt="" />
                                            <span className="modal-picker-item-text">{item.name}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>

                {/* Modal Filter Urutkan */}
                <div className={'modal-picker-overlay' + (this.state.modalOpen === 'order' ? ' show' : '')} onClick={() => {this.closeModal()}}>
                    <div className="modal-picker-sheet" onClick={(e) => {e.stopPropagation()}}>
                        <div className="modal-picker-handle"></div>
                        <div className="modal-picker-header modal-picker-header-light">
                            <div className="modal-picker-title modal-picker-title-dark">Urutkan</div>
                            <button type="button" className="modal-picker-close modal-picker-close-light" onClick={() => {this.closeModal()}}>
                                <i className="fi-rs-cross"></i>
                            </button>
                        </div>
                        <div className="modal-picker-list">
                            {
                                this.state.dataFilterOrder.map((item, i) => {
                                    const active = this.state.selectedIdOrder === item.value;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item modal-picker-item-flat' + (active ? ' active' : '')}
                                            onClick={() => {this.selectOrder(item.value)}}
                                        >
                                            <span className="modal-picker-item-text">{item.name}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Wishlist;
